import { useState } from "react";
import Api from "../Apis";
import axios from "axios";
import { AppLoading } from "../Loading";
import { DisplayResults } from "../helper/DisplayResult";
import { ImportsNav } from "./ImportsNav";

export const ExcelUploadForm = () => {
  const [file, setFile] = useState(null);
  const [actionType, setActionType] = useState("import"); // Default to 'import'
  const [loading, setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [returns, setReturns] = useState([]);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!file) {
      alert("Please select an Excel file first.");
      return;
    }

    setLoading(true);

    // Prepare Multipart Form Data
    const formData = new FormData();
    formData.append("file", file);

    // Determine target URL based on selected Action Type (Import vs Export)
    const targetUrl =
      actionType === "import"
        ? Api.excel.value + "/import"
        : Api.excel.value + "/export";

    axios
      .post(targetUrl, formData, {
        headers: {
          ...Api.Token,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        setReturns(res.data);
        setLoading(false);
        setShowResults(true);
        setFile(null);
        event.target.reset(); // Reset form inputs
      })
      .catch((err) => {
        setLoading(false);
        console.error("Upload error:", err);
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("token");
          window.location.replace("/");
          alert("Session expired. Please log in again.");
        } else {
          alert(`Failed to upload ${actionType} Excel file.`);
        }
      });
  };

  return (
    <div>
      <ImportsNav />
      {showResults && (
        <DisplayResults returns={returns} setDisplay={setShowResults} />
      )}

      <div className="mt-4 container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card shadow-sm p-4">
              <h2 className="text-center mb-4">Excel Batch Upload</h2>
              <form onSubmit={handleSubmit} className="form was-validated">
                
                {/* Action Type Dropdown */}
                <div className="mb-3">
                  <label htmlFor="actionType" className="form-label font-weight-bold">
                    Select Action Type
                  </label>
                  <select
                    id="actionType"
                    className="form-select form-control"
                    value={actionType}
                    onChange={(e) => setActionType(e.target.value)}
                    required
                  >
                    <option value="import">Import Products (Stock In)</option>
                    <option value="export">Export Products (Stock Out / Sell)</option>
                  </select>
                </div>

                {/* File Input */}
                <div className="mb-3">
                  <label htmlFor="excelFile" className="form-label">
                    Select Excel File (.xlsx / .xls)
                  </label>
                  <input
                    type="file"
                    id="excelFile"
                    accept=".xlsx, .xls"
                    className="form-control"
                    onChange={handleFileChange}
                    required
                  />
                </div>

                {/* Dynamic Submit Button */}
                <div className="d-grid gap-2 mt-4">
                  <button
                    type="submit"
                    className={`btn w-100 ${
                      actionType === "import" ? "btn-primary" : "btn-warning"
                    }`}
                    disabled={loading || !file}
                  >
                    {loading
                      ? "Processing..."
                      : `Upload for ${actionType.toUpperCase()}`}
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>

      <div style={loading ? { display: "block" } : { display: "none" }}>
        <AppLoading />
      </div>
    </div>
  );
};